import { Button, Spinner, StatusBadge } from '@apollo/orbit';
import React from 'react';

import { Code } from 'src/components/code/Code';
import Config from 'src/lib/config';
import { escapeShellArgument } from 'src/lib/escapeShellArgument';
import { notProduction } from 'src/lib/notProduction';

const STAGING_CODE = `import { ApolloServerPluginSchemaReporting } from "apollo-server-core";
const server = new ApolloServer({
  typeDefs,
  resolvers,
  plugins: [
    ApolloServerPluginSchemaReporting({
      endpointUrl: ${JSON.stringify(Config.stagingSchemaEndpoint)}
    }),
  ],
});`;

export const SchemaReportingTab = ({
  firstPublish,
  serviceApiToken,
  graphId,
  graphVariant,
  __test,
  onClose,
}: {
  firstPublish: boolean;
  serviceApiToken: string;
  graphId: string;
  graphVariant: string;
  __test?: {
    staging?: boolean;
  };
  onClose?: () => void;
}) => {
  return (
    <>
      {firstPublish ? (
        <p>
          Pick this option when you want Apollo Server to automatically push its
          schema when it starts. This is the easiest way to keep your schema
          current in Studio and requires no further maintenance or installation.
          (You must be using Apollo Server v2.15.0+ to use this option.)
        </p>
      ) : (
        <p>
          Set up Apollo Server to automatically push its schema when it starts.
          This is the easiest way to keep your schema current in Studio and
          requires no further maintenance or installation. (You must be using
          Apollo Server v2.15.0+ to use this option.)
        </p>
      )}
      <p className="mt-2">
        All you have to do is set the following variables in your server's
        environment:
      </p>
      <Code
        className="my-4"
        mask={serviceApiToken.split(':').pop()}
        code={[
          firstPublish
            ? `APOLLO_KEY=${escapeShellArgument(
                serviceApiToken ?? '[INSERT API KEY HERE]',
              )}`
            : `APOLLO_KEY=[INSERT API KEY HERE]`,
          `APOLLO_GRAPH_REF=${escapeShellArgument(
            graphId,
          )}@${escapeShellArgument(graphVariant)}`,
          `APOLLO_SCHEMA_REPORTING=true`,
        ]
          .filter((a) => a)
          .join('\n')}
      />
      {(__test?.staging ?? notProduction) && (
        <div>
          Because this is the staging Studio, you'll also have to configure the
          schema reporting plugin to talk to staging:
          <Code className="my-4" showLineNumbers={true} code={STAGING_CODE} />
        </div>
      )}
      <div className="mt-8 flex items-center">
        {firstPublish && (
          <StatusBadge icon={<Spinner size="xs" />}>
            Awaiting schema
          </StatusBadge>
        )}
        {onClose && (
          <div className="flex flex-1 justify-end">
            <Button
              variant="primary"
              type="submit"
              className="flex-none"
              onClick={onClose}
            >
              Done
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
